/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
const e=["begin","end","begin-end"],n=["arrow","circle","square","diamond","cross","x"];export{e as lineMarkerPlacements,n as lineMarkerStyles};
